module.exports = __webpack_public_path__ + "media/images/v2/logo-footer-d9fe6261c33f4e2216b30a8b85a07116.png";